import { useCallback, useEffect, useMemo, useState } from 'react'
import { Breadcrumb, Button, Card, Col, Form, Input, notification, Row, Select, Typography } from 'antd'
import { EditOutlined, HomeOutlined, LeftCircleOutlined, PlusCircleOutlined } from '@ant-design/icons'
import { useHistory, useParams } from 'react-router-dom'
// import { CKEditor } from 'ckeditor4-react'
import { useStore } from 'src/hooks'
import { debounce } from 'lodash'
import FloatLabel from 'src/common/components/float-label'
import { useTranslation } from 'react-i18next'
import i18n from 'src/helpers/i18n'
import { createValidationRules } from 'src/helpers/validateRule'
import { observer } from 'mobx-react-lite'
import { useLoading } from 'src/common/components/LoadingContainer'
import { TYPE_PROMOTION } from 'src/helpers/constants'
import moment from 'moment'
import TextArea from 'antd/lib/input/TextArea'

const { Title } = Typography

const NotificationCreateScreen = observer(() => {
   const history = useHistory()
   const [form] = Form.useForm()
   const UserStore = useStore('UserStore')
   const { t } = useTranslation()
   const { id } = useParams<{ id: string }>()
   // const ckeditorRef = useRef<any>()
   const { showLoading, hideLoading } = useLoading()
   const [detail, setDetail] = useState<any>(null)

   const readOnly = useMemo(() => {
      if (history.location.pathname.includes('detail')) {
         return true
      } else {
         return false
      }
   }, [history.location])

   // Re-create rules when language changes
   const rule = useMemo(() => createValidationRules(), [i18n.language])

   const getListFilterProvince = async () => {
      await UserStore.getProvince({})
   }
   useEffect(() => {
      getListFilterProvince()
      if (id && id !== 'create') {
         handleGetDetail()
      }
   }, [id])

   // Fetch detail thông tin kênh bán hàng
   const handleGetDetail = useCallback(async () => {
      if (!id) {
         return
      }
      try {
         showLoading()

         if (UserStore.locationSelected) {
            setDetail(UserStore.locationSelected)
            form.setFieldsValue({
               ...UserStore.locationSelected
            })

            // setTimeout(() => {
            //    //@ts-ignore
            //    ckeditorRef.current?.setData?.(fetchedDetail?.des)
            // }, 500)
         }
      } finally {
         hideLoading()
      }
   }, [])

   const onFinish = async (values: any) => {
      // Kiểm tra từng field required
      // for (const field of requiredFields) {
      //    const fieldValue = values[field.key]

      //    if (!fieldValue || (typeof fieldValue === 'string' && fieldValue.trim() === '')) {
      //       setActiveTab(field.tab)
      //       return // Dừng lại ngay khi phát hiện lỗi
      //    }
      // }
      console.log('values', values)

      // Submit the sanitized data
      const data = await UserStore.createNotification(values)
      console.log('data', data, ' id', id)

      if (data) {
         notification.open({
            message: t('notification'),
            description: t('create_successfully'),
            type: 'success',
            placement: 'topRight'
         })

         history.goBack()
      }
   }

   const renderContent = () => {
      return (
         <div style={{ pointerEvents: readOnly ? 'none' : 'all' }}>
            <Card style={{ width: '100%', marginTop: '20px' }}>
               <Row
                  className="gx-flex-row"
                  gutter={12}
                  style={{
                     flex: 1,
                     justifyContent: 'space-between',
                     alignItems: 'center',
                     paddingLeft: 0,
                     paddingRight: 0
                  }}
               >
                  <Col xs={24} md={24}>
                     <FloatLabel label={'Nhóm tài khoản'} required>
                        <Form.Item name="role" rules={[rule.requiredEnter]}>
                           <Select placeholder={t('select')}>
                              <Select.Option value={'all'}>{'Tất cả'}</Select.Option>
                              <Select.Option value={'user'}>{'Khách hàng'}</Select.Option>
                              <Select.Option value={'driver'}>{'Tài xế'}</Select.Option>
                           </Select>
                        </Form.Item>
                     </FloatLabel>
                  </Col>
                  <Col xs={24} md={24}>
                     <FloatLabel label={'Tiêu đề'} required>
                        <Form.Item name="title" rules={[rule.requiredEnter]}>
                           <Input placeholder={t('enter')} />
                        </Form.Item>
                     </FloatLabel>
                  </Col>
                  <Col xs={24} md={24}>
                     <FloatLabel label={'Nội dung'} required>
                        <Form.Item name="message" rules={[rule.requiredEnter]}>
                           <TextArea placeholder={t('enter')} />
                        </Form.Item>
                     </FloatLabel>
                  </Col>
               </Row>
            </Card>
         </div>
      )
   }

   return (
      <div>
         <Row style={{ padding: '0 20px' }} className="gx-justify-content-between gx-align-items-center">
            <Col>
               <Title level={4}>{'Thông báo'}</Title>
               <Breadcrumb>
                  <Breadcrumb.Item href="/">
                     <HomeOutlined className="gx-link" />
                  </Breadcrumb.Item>
                  <Breadcrumb.Item>{'Admin'}</Breadcrumb.Item>
                  <Breadcrumb.Item onClick={() => history.goBack()} className="gx-link">
                     {'Thông báo'}
                  </Breadcrumb.Item>
                  <Breadcrumb.Item>{t('add_new')}</Breadcrumb.Item>
                  {id && <Breadcrumb.Item>{id}</Breadcrumb.Item>}
               </Breadcrumb>
            </Col>
         </Row>
         <Form
            form={form}
            name="basic"
            initialValues={{}}
            autoComplete="off"
            layout="vertical"
            onFinish={debounce(onFinish, 600)}
            onFinishFailed={(errorInfo) => {
               console.log('Validation Failed:', errorInfo)
            }}
         >
            {renderContent()}
            <Form.Item style={{ width: '100%', textAlign: 'center' }}>
               {readOnly ? (
                  <Button
                     icon={<LeftCircleOutlined />}
                     type="dashed"
                     style={{ color: '#ED5C19' }}
                     onClick={() => history.goBack()}
                  >
                     {t('txt_back')}
                  </Button>
               ) : (
                  <>
                     <Button
                        icon={<LeftCircleOutlined />}
                        type="dashed"
                        style={{ color: '#ED5C19' }}
                        onClick={() => history.goBack()}
                        className="gx-mr-2"
                     >
                        {t('txt_back')}
                     </Button>
                     <Button icon={<PlusCircleOutlined />} type="primary" htmlType="submit" className="gx-mr-2">
                        {t('create')}
                     </Button>
                  </>
               )}
            </Form.Item>
         </Form>
      </div>
   )
})

export default NotificationCreateScreen
